module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Playlist2-783d62b3a95d2b2d2602d9c151d88d67.svg";